import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("textBlock2", component(opts));
  editor.BlockManager.add("textBlock2", block(opts));
};